import React from 'react'
import Reflux from 'reflux'
import {
	ButtonGroup,
	Button
} from 'reactstrap'
import _ from 'lodash'

import QuantitiesStore from '~/stores/quantities.js'
import QuantitiesActions from '~/actions/quantities.js'


export default class RecipeQuantitiesModalList extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = QuantitiesStore
	}

	render() {
		const letterButtons = (
			_.has(this.state, 'quantities')
			&& _.size(this.state.quantities) > 0
		)
			? _.uniq(_.map(this.state.quantities, 'firstLetter')).map(
				theLetter =>
					<Button
						key={theLetter}
						color="info"
						active={this.state.quantityFilterLetter === theLetter}
						onClick={() => QuantitiesActions.setFilterLetter(theLetter)}
					>
						{theLetter}
					</Button>
				)
			: null

		return (
			<ButtonGroup>
				<Button
					color="info"
					active={this.state.quantityFilterLetter === ''}
					onClick={() => QuantitiesActions.setFilterLetter('')}
				>
					ALL QUANTITIES
				</Button>
				{letterButtons}
			</ButtonGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/quantities/listFilterBar.jsx